export { default } from './ProductDetail';